// Material UI
import { Theme } from "@mui/material/styles";
import Tabs, { TabsProps } from "@mui/material/Tabs";
import classNames from "classnames";
interface ITabs extends TabsProps {
  children?: any;
  className?: string;
  onChange?: (event: any, value: any) => void;
}

const OCTabsStyles = (theme: Theme): any => ({
  ocTabs: {
    minHeight: "32px",
    color: theme.palette.text.primary,
    "& .MuiTabScrollButton-root": {
      "&.MuiTabs-scrollButtons.MuiTabs-scrollButtonsDesktop.Mui-disabled": {
        display: "none",
      },
    },
    "& .MuiTabs-indicator": {
      top: 0,
      backgroundColor: theme.palette.secondary.main,
    },
    "& .MuiTabs-flexContainer": {
      height: "100%",
    },
    "& button.MuiTab-root": {
      color: theme.palette.text.primary,
      fontSize: "0.875rem",
      opacity: 0.7,
      minHeight: "32px",
      minWidth: "50px",
      maxWidth: "500px",
      textTransform: "capitalize",
      whiteSpace: "nowrap",
      fontWeight: 400,
      transition: theme.transitions.create(["backgroundColor", "opacity"]),
      borderRight: `2px solid ${theme.custom.timeline.contextListBackground}`,
      "&.dirty": { color: theme.custom.forms.dirtyColor },
      "&:hover": { color: theme.palette.text.primary, opacity: 1 },
      "&.Mui-selected": {
        backgroundColor: theme.custom.timeline.contextListBackground,
        opacity: 1,
      },
      "&.MuiTab-wrapped": {
        display: "flex",
        flexDirection: "row-reverse",
        padding: "0px 10px",
        margin: 0,
        whiteSpace: "nowrap",
        "& .MuiSvgIcon-root": {
          width: "14px",
          height: "14px",
          border: "1px solid",
          borderRadius: "3px",
          margin: "0px 0px 0px 5px",
        },
      },
    },
    "&.MuiTabs-vertical": {
      "& button.MuiTab-root": {
        borderBottom: `2px solid ${theme.custom.timeline.contextListBackground}`,
        borderRight: "none",
        "&.MuiTab-wrapped": {
          padding: "8px 5px",
        },
      },
      "& .MuiTabs-indicator": {
        left: 0,
      },
    },
  },
});

export const OcTabs = (props: ITabs): JSX.Element => {
  const { className } = props;

  return (
    <Tabs {...props} className={classNames(className)} sx={(theme) => OCTabsStyles(theme).ocTabs}>
      {props.children}
    </Tabs>
  );
};
